var OCS = OCS || {};
OCS.Viewer = OCS.Viewer || {};
OCS.Viewer.Classes = OCS.Viewer.Classes || {};
OCS.Viewer.Functions = OCS.Viewer.Functions || {};
OCS.Viewer.Functions.define_AdvisoryLayer = function (in_implements, in_extends, options) {
    var class_definition = OCS.Viewer.Functions.define_BaseLayer(in_implements, in_extends, options);
    return new Class({
        Extends: class_definition,
        debug: false,
        class_name: "AdvisoryLayer",
        advisory_popup: null,
        over_advisory_popup: false,
        lock_advisory_popup: false,
        advisory_info_template: null,
        advisory_text_popup: null,
        featureOverlay: null,
        overlay: null,
        date_obj: null,
        options: {
            'update_interval': 900000, //15min
            'panel_div_class': '.panel',
            style_type: 'advisory',
            source_type: 'Advisory'
        },
        create: function () {
            var sm = this.get_style_manager();
            var layer_ops = {};
            var source = this.get_source();
            layer_ops.style = sm.get_layer_style_method();
            if (source) {
                //source.setStyle(sm.get_layer_style_method());
                layer_ops.source = source;
            }

            var layer = new ol.layer.Vector(layer_ops);
            this.set_layer(layer);
            return layer;
        },
        create_layer_legend: function (contianer) {

        },
        set_source_obj: function (source) {
            // Verify the incoming source is what we are expecting
            if (source && source.class_type === "Source" && source.class_name === this.options.source_type + "Source") {
                this.source_obj = source;
                this.set_layer_source();
                if (this.source_obj.ready) {
                    this.ready();
                } else {
                    this.source_obj.addEvent('ready', this.ready.bind(this));
                }

            }
        },
        set_dateObj: function (dateObj) {
            if (!this.date_obj) {
                this.date_obj = dateObj;
            }
        },
        get_dateObj: function () {
            return this.date_obj;
        },
        get_timestamp_epoch: function () {
            return this.date_obj.get_current_epoch_time();
        },
        get_style_manager: function () {
            var sm = this.parent();
            // Done this way so that if a style type were to be applied that is seperate from the default, it does not get sabatoged by the default option when a new layer is created
            if (this.options.style_type && sm.get_style_type() === null) {
                sm.set_style_type(this.options.style_type);
            }
            return sm;
        }
    });
};
OCS.Viewer.Classes.AdvisoryLayer = OCS.Viewer.Functions.define_AdvisoryLayer();
